module.exports = __webpack_public_path__ + "static/media/sipec02.e4954c84.png";